import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import { usePageTracker } from "./hooks/use-page-tracker";

// Lazy-loaded routes — keeps initial JS bundle small
const Contacto = lazy(() => import("./pages/Contacto"));
const PoliticaPrivacidad = lazy(() => import("./pages/PoliticaPrivacidad"));
const TerminosCondiciones = lazy(() => import("./pages/TerminosCondiciones"));
const TratamientoDatos = lazy(() => import("./pages/TratamientoDatos"));
const InvestmentBanking = lazy(() => import("./pages/servicios/InvestmentBanking"));
const CorporateFinanceFPA = lazy(() => import("./pages/servicios/CorporateFinanceFPA"));
const CFOAsAService = lazy(() => import("./pages/servicios/CFOAsAService"));
const CapitalYDeuda = lazy(() => import("./pages/servicios/CapitalYDeuda"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Insights = lazy(() => import("./pages/Insights"));
const AdminLogin = lazy(() => import("./pages/admin/Login"));
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));
const CampanaEmail = lazy(() => import("./pages/admin/CampanaEmail"));

const queryClient = new QueryClient();

function AppRoutes() {
  usePageTracker();
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/terminos" element={<TerminosCondiciones />} />
            <Route path="/datos" element={<TratamientoDatos />} />
            <Route path="/servicios/investment-banking" element={<InvestmentBanking />} />
            <Route path="/servicios/corporate-finance" element={<CorporateFinanceFPA />} />
            <Route path="/servicios/cfo-as-a-service" element={<CFOAsAService />} />
            <Route path="/servicios/capital-y-deuda" element={<CapitalYDeuda />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/campana-email" element={<CampanaEmail />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
